export default {
  bind (el, binding, vnode) {
    vnode.context.$nextTick(function () {
      let fixedHeaderHeight = 0
      let scrollEl = document.getElementById('app-panel') || window
      if (typeof binding.value === 'number') {
        fixedHeaderHeight = binding.value
      } else if (binding.value && typeof binding.value === 'object') {
        fixedHeaderHeight = binding.value.offset
        scrollEl = binding.value.scrollElId ? document.getElementById(binding.value.scrollElId) : window
      }
      const getElemScrollY = () => scrollEl === window ? scrollEl.scrollY : scrollEl.scrollTop
      if (scrollEl) {
        const offsetTop = el.getBoundingClientRect().top - fixedHeaderHeight + getElemScrollY()
        const parentClassList = el.parentNode.classList
        let requesting = false

        const frame = () => {
          if (getElemScrollY() >= offsetTop) {
            parentClassList.add('sticky-nav')
          } else {
            parentClassList.remove('sticky-nav')
          }
          requesting = false
        }

        binding.scrollEl = scrollEl
        binding.scroll = () => {
          if (!requesting) {
            requestAnimationFrame(frame)
            requesting = true
          }
        }

        binding.scroll()
        scrollEl.addEventListener('scroll', binding.scroll)
      }
    })
  },

  unbind (el, binding) {
    binding.scrollEl && binding.scrollEl.removeEventListener('scroll', binding.scroll)
  }
}
